import { Navigate, useLocation } from 'react-router-dom';
import { useAuthStore, hasFunction } from '../../stores/authStore';

interface PermissionRouteProps {
  requiredFunction?: string;
  children: React.ReactNode;
}

/**
 * 权限路由守卫组件
 * 用于保护需要特定权限才能访问的路由
 *
 * @param requiredFunction - 访问此路由需要的功能码
 * @param children - 有权限时渲染的子组件
 *
 * 使用示例:
 * <PermissionRoute requiredFunction="organization_list_view">
 *   <OrganizationListPage />
 * </PermissionRoute>
 */
export default function PermissionRoute({ requiredFunction, children }: PermissionRouteProps) {
  const location = useLocation();
  const { user, isAuthenticated } = useAuthStore();

  // 如果未登录，重定向到登录页（这种情况通常不会发生，因为外层有 ProtectedRoute）
  if (!isAuthenticated) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  // 如果需要权限但用户没有该权限，重定向到首页
  if (requiredFunction && !hasFunction(user, requiredFunction)) {
    return <Navigate to="/home" replace />;
  }

  // 有权限，渲染子组件
  return <>{children}</>;
}
